import {WindowRef} from '../../providers/window';
import {Component, OnInit} from '@angular/core';
import html2canvas from 'html2canvas';


@Component({
  selector: 'app-stack',
  templateUrl: './component.html',
  styleUrls: ['./component.css']
})
export class StackComponent implements OnInit {

  constructor(private window: WindowRef) {
    this.window.nativeWindow.mixpanel.track("Stack: Page start");
    // setInterval(() => {
    //   html2canvas(document.querySelector("body")).then(canvas => {
    //     console.log(canvas.toDataURL());
    //     this.window.nativeWindow.open(canvas.toDataURL());
    //   });
    // }, 1000)
  }

  ngOnInit() {document.getElementsByTagName('iframe')[0].style.height = window.innerHeight - 50 + 'px'}
}



// WEBPACK FOOTER //
// /home/manu/ArtCode/artCode/artCode/src/app/pages/stack/component.ts